/* jshint esnext:true */

import * as React from 'react';
import ReactDOM from 'react-dom';
import AnnouncementBox from './components/AnnouncementBox';

export default function renderAnnouncementBox(data, container) {
    return ReactDOM.render(React.createElement(AnnouncementBox, data, null), container);
}
